import { UserLevel } from '@app/core/models/user-level';

interface LevelMapping {
  isActive: (url: string) => boolean;
  userLevel: UserLevel;
}

export const UserLevelMapping: LevelMapping[] = [
  {
    isActive: (url) => {
      const userLevel = /^\/reseller.*enterprises\/.*\/users\/.*\//.test(url);
      const adapterLevel = /^\/reseller.*enterprises\/.*\/users\/adapters.*/.test(url);

      return userLevel && adapterLevel === false;
    },
    userLevel: UserLevel.EndUser,
  },
  {
    isActive: (url) => /^\/reseller.*enterprises\/.*/.test(url),
    userLevel: UserLevel.EnterpriseAdmin,
  },
  {
    isActive: (url) => /^\/reseller/.test(url),
    userLevel: UserLevel.ServiceProviderAdmin,
  },
  {
    isActive: (url) => url.startsWith('/reseller') === false,
    userLevel: UserLevel.SystemAdmin,
  },
];
